import { render, staticRenderFns } from "./UserProfileWebpart.vue?vue&type=template&id=4639621c"
import script from "./UserProfileWebpart.ts?vue&type=script&lang=ts&external"
export * from "./UserProfileWebpart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports